import { Component, computed, Injector, input, OnInit, signal } from '@angular/core';
import { TelephoneLinkComponent } from '../../../../../../../../shared/components/telephone-link/telephone-link.component';
import { PostCode } from '../../../../../../../../global/postcode';
import { toObservable } from '@angular/core/rxjs-interop';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-manual-signposting',
  imports: [TelephoneLinkComponent, TitleCasePipe],
  templateUrl: './manual-signposting.component.html',
  styleUrl: './manual-signposting.component.scss',
})
export class ManualSignpostingComponent implements OnInit {
  postCode = input.required<string>();
  repairer = input.required<string>();
  contactNumber = input.required<string>();
  callCostMessaging = signal<string>('');

  protected viewModel = computed(() => {
    return {
      callCostMessaging: this.callCostMessaging(),
      repairer: this.repairer(),
      contactNumber: this.contactNumber(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly injector: Injector) {}

  ngOnInit() {
    toObservable(this.postCode, { injector: this.injector }).subscribe((postcode) => {
      if (postcode === '' || !postcode) return;
      this.generateCallCostMessaging(postcode);
    });
  }

  generateCallCostMessaging(postcode: string | undefined): void {
    if (!postcode) return;
    PostCode.getCallCostMessagingForPostCode(postcode).subscribe({
      next: (message) => {
        this.callCostMessaging.set(message);
      },
    });
  }
}
